import { IReturnDelivery } from '@alberta/konexi-shared';
import { Inject, Injectable, NgZone } from '@angular/core';
import { ReturnDeliveryChannel } from 'src/app/business/return-delivery/contracts/return-delivery-channel';
import { IAppController } from 'src/app/common/contracts/controller/app-controller';
import { IDispatcher } from 'src/app/common/contracts/dispatch/dispatcher';
import { IPlatformSync, PlatformSyncToken } from 'src/app/common/contracts/sync/platform-sync';
import { AppController } from 'src/app/common/controller/app-controller';
import { Dispatcher } from 'src/app/common/dispatch/dispatcher';

import { ReturnDeliveryModelName } from '../../models/model-names';
import { SyncProgressEvent } from '../../models/sync-progress-event';
import { EventService } from '../event.service';
import { SyncService } from './sync.service';

@Injectable()
export class ReturnDeliverySyncService extends SyncService<IReturnDelivery> {
  constructor(
    @Inject(AppController) appController: IAppController,
    @Inject(Dispatcher) dispatcher: IDispatcher<IReturnDelivery>,
    eventService: EventService<SyncProgressEvent>,
    ngZone: NgZone,
    @Inject(PlatformSyncToken) platformSync: IPlatformSync
  ) {
    super(ReturnDeliveryModelName, appController, dispatcher, eventService, ngZone, platformSync);
  }

  public async afterPatch(entity: IReturnDelivery): Promise<void> {
    return this.onPatched(entity);
  }

  public canSync(channel: string): boolean {
    return (
      channel === ReturnDeliveryChannel.CREATE ||
      channel === ReturnDeliveryChannel.EDIT ||
      channel === ReturnDeliveryChannel.DELETE
    );
  }
}
